import { Button } from '@chakra-ui/react';
import NextLink from 'next/link';
import React from 'react';

interface ProceedToRegistrationProps {
  isAuthenticated: boolean;
  signInUrl: string;
  onProceed: () => void;
  isLoading: boolean;
  isDisabled: boolean;
  /** Course / Intuto collection: enrollment wording */
  useEnrollmentCopy?: boolean;
}

export const ProceedToRegistrationButton: React.FC<ProceedToRegistrationProps> = ({
  isAuthenticated,
  signInUrl,
  onProceed,
  isLoading,
  isDisabled,
  useEnrollmentCopy,
}) => {
  if (!isAuthenticated) {
    return (
      <Button
        as={NextLink}
        href={signInUrl}
        colorScheme="primary"
        size="lg"
        width="100%"
      >
        Sign In
      </Button>
    );
  }

  return (
    <Button
      onClick={onProceed}
      colorScheme="primary"
      size="lg"
      width="100%"
      isLoading={isLoading}
      loadingText="Proceeding..."
      isDisabled={isDisabled}
    >
      {useEnrollmentCopy ? 'Proceed to Enrollment' : 'Proceed to Registration'}
    </Button>
  );
};